import type { ComplianceBand } from '../../../lib/api/queries';

// Band → colour map for the scorecard pills, the overall card and the
// compliance-by-section charts.
//
// Muted traffic-light palette: still tells the red-to-green story at a
// glance, but the shades are desaturated so the scorecard reads like a
// professional report rather than a dashboard alarm. Mirrored by
// ComplianceBandColours in the PDF renderer; change both together.
export const BAND_COLORS: Record<ComplianceBand, string> = {
  VeryHigh:      '#5AA576',   // muted sage green — best
  High:          '#9DB86E',   // soft olive       — good
  Medium:        '#E1B96B',   // warm sand        — attention
  Low:           '#D68B5C',   // terracotta       — needs work
  VeryLow:       '#C97878',   // dusty rose       — urgent
  NotApplicable: '#9CA3AF',   // gray-400         — neutral
};

export function bandLabel(band: ComplianceBand): string {
  switch (band) {
    case 'NotApplicable': return 'N/A';
    case 'VeryLow':       return 'Very low';
    case 'VeryHigh':      return 'Very high';
    default:              return band;
  }
}
